export function findByKeyValue (array, key, value) {
  return array.find(item => item[key] === value)
}

export function findById (array, id) {
  return findByKeyValue(array, 'id', id)
}
